import '../../modules/mode-components';

import * as angular from 'angular';

import { AngularEventCallback } from '../../common/types';

class SharingBannerController {
  onDismiss: AngularEventCallback<Event>;
  reportIsShared: boolean;
  reportIsEmbedded: boolean;
  reportIsWhiteLabelEmbedded: boolean;

  dismiss($event: MouseEvent) {
    this.onDismiss({ $event });
  }

  currentSharing() {
    return this.reportIsShared ? 'ON' : 'OFF';
  }

  currentEmbed() {
    return this.reportIsEmbedded ? 'ON' : 'OFF';
  }

  currentWhiteLabelEmbed() {
    return this.reportIsWhiteLabelEmbedded ? 'ON' : 'OFF';
  }
}

const SharingBannerComponent: angular.IComponentOptions = {
  bindings: {
    onDismiss: '&',
    reportIsEmbedded: '<',
    reportIsShared: '<',
    reportIsWhiteLabelEmbedded: '<',
  },
  controller: SharingBannerController,
  controllerAs: 'ctrl',
  template: `
<div class="header-banner">
  <div class="content">
    <span ng-if="ctrl.reportIsShared"><i class="icon icon-external-sharing"></i> External sharing {{ ctrl.currentSharing() }}</span>
    <span ng-if="ctrl.reportIsEmbedded"><i class="icon icon-embed-narrow-black"></i> Secret embedding {{ ctrl.currentEmbed() }}</span>
    <span ng-if="ctrl.reportIsWhiteLabelEmbedded"><i class="icon icon-embed-narrow-black"></i> White-Label embedding {{ ctrl.currentWhiteLabelEmbed() }}</span>
    <button class="btn btn-dismiss" ng-click="ctrl.dismiss($event)"><i class="icon icon-fail-inverted"></i></button>
  </div>
</div>`,
};

angular.module('mode.components').component('sharingBanner', SharingBannerComponent);
